<template>
    <h1 class="font-bold text-dark" :class="type === 'title' ? 'text-4xl' : 'text-2xl'">
        <slot></slot>
    </h1>
</template>

<script>
export default {
    props: {
        type: {
            default: 'title',
            type: String
        }
    }
};
</script>


<style >

</style>
